import React from 'react';
import UpcomingJoineeTable from './upcomingjoineetable';


function PositionStatus(props: any) {

  // const series = [
  //   {
  //     name: "January 2022",
  //     data: [parseInt(props && props.chartData && props.chartData.payrollForCurrentMonth)],
  //   },
  //   {
  //     name: "February 2022",
  //     data: [parseInt(props && props.chartData && props.chartData.payrollForPastMonth)],
  //   },
  //   {
  //     name: "March 2022",
  //     data: [parseInt(props && props.chartData && props.chartData.payrollForPreviousMonth)],
  //   }
  // ];

  // const series = props && props.chartData && props.chartData.map((item: any) => {
  //   return (
  //     {
  //       name: item.month,
  //       data:[item.value]
  //     }
  //   )
  // }
  // )
  
  // const selectColor = (data: any) => {
    
  //   switch (data) {
  //     case 0:
  //       return '#FFC633'
  //     case 1:
  //       return '#344F97'
  //     case 2:
  //       return '#14A800'
  //   }
    
  // }

  
  return (
    <section className="infoCardGrid">
        <UpcomingJoineeTable data={props.tableData} />
        {/* <div className="halfGrid">
          <UpcomingJoineeTable data={props.tableData} />
        </div>
        <div className="halfGrid">
          <ChartGraph data={series} selectColour={selectColor} />
        </div> */}
    </section>
  )
}

export default PositionStatus